import {useActions, useGetters, useMutators, useState} from './_default.js';
import {MAP_OBJECT_TYPE_OBJECT} from "@/js/constants";
import axios from "axios";
import ObjectPopup from "@/js/Components/MapPopup/ObjectPopup.vue";

export default {
    namespaced: true,
    state: {
        ...useState(),
        mapObjectsLoadUrl: 'payload/paginated/map/object',
        listUrl: '/payload/paginated/sidebar/object',
        updateInterval: 5000,
        popupComponent: ObjectPopup,
        layers: null,

        latestSelected: null,

        fallow: true,
        fallowLoaded: false,
        fallowTimestamp: null,
        fallowTimer: null,
        fallowIds: [],

        params: { grouped: 1 },
        animate: null,
        showTotalDistance: false,
        showFullAddress: false,
        hash: null,

        updates: true,

        customDeviceAdd: false,
        listView: false,
        devicesInView: false,
    },
    getters: {
        ...useGetters(),
        hash: state => state.hash,
        updateInterval: state => state.updateInterval,
        animate: state => state.animate,
        customDeviceAdd: state => state.customDeviceAdd,
        updateTimestamp: state => state.updateTimestamp,
        showTotalDistance: state => state.showTotalDistance,
        showFullAddress: state => state.showFullAddress,
        listView: state => state.listView,
        fallowLoaded:  state => state.fallowLoaded,
        loadFallow:  state => {
            state.fallowLoaded = true;
            return state.fallowIds;
        },
        devicesInView: state => state.devicesInView,
    },
    mutations: {
        ...useMutators(),

        devicesInViewStatus(state, status) {
            state.devicesInView = status;
        },

        listView(state, status) {
            state.listView = status;
        },

        sharingHash(state, hash) {
            state.hash = hash;
        },

        animate(state, animate) {
            state.animate = parseInt(animate);
        },

        showTotalDistance(state, status) {
            state.showTotalDistance = !!status;
        },

        showFullAddress(state, status) {
            state.showFullAddress = !!status;
        },

        updateTimestamp(state, time) {
            state.updateTimestamp = time;
        },

        fallow(state, id) {
            if (!id) return;
            const index = state.fallowIds.findIndex(v => v.toString() === id.toString());
            if (index !== -1) return;
            state.fallowIds.push(id);
        },

        unFallow(state, id) {
            if (!id) return;
            const index = state.fallowIds.findIndex(v => v.toString() === id.toString());
            if (index === -1) return;
            state.fallowIds.splice(index, 1);
        },

        customDeviceAdd(state, status) {
            state.customDeviceAdd = status;
        },

        select(state, id) {
            state.selected = id;
            if (!id) return;
            state.latestSelected = id;
        },

        selectLatestSelected(state) {
            state.selected = state.latestSelected;
        }
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/devices/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
        uploadImage({ state }, { id, data }) {
            return new Promise((resolve, reject) => {
                axios.post(`/object/image/${id}`, data).then((response) => {
                    resolve();
                });
            });
        },
        deleteImage({ state }, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`/object/image/${id}`).then((response) => {
                    resolve();
                });
            });
        },

        load({state, dispatch}, id) {
            return dispatch('loadMapObjects', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params: { id, full: true },
                add: false
            })
        },

        startFallow({ state, dispatch}) {
            state.fallow = true;
            dispatch('fallow');
        },

        stopFallow({ state, dispatch }) {
            clearTimeout(state.fallowTimer);
            state.fallow = false;
        },

        fallow({ state, dispatch }) {
            clearTimeout(state.fallowTimer);
            if (!state.fallow || !state.fallowIds.length) {
                state.fallowTimer = setTimeout(() => {
                    dispatch('fallow');
                }, state.updateInterval);
                return;
            }

            const params = {
                fallow: state.fallowIds,
                time: state.fallowTimestamp
            };
            dispatch('loadMapObjects', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params,
                add: false
            }).then((response) => {
                state.fallowTimestamp = response.headers.time;
                state.fallowTimer = setTimeout(() => {
                    dispatch('fallow');
                }, state.updateInterval);
            });
        },

        sendGprsCommand({ state }, data) {
            return new Promise((resolve, reject) => {
                const url = data.url || '/command/send/gprs';
                delete data.url;
                axios.post(url, data).then((response) => {
                    const result = parseSendCommandResponse(response.data);
                    result?.type === 'error' || result?.type === 'warning' ? reject(result) : resolve(result);
                }).catch((error) => {
                    reject(parseSendCommandError(error));
                });
            });
        },
    },
}

export function parseSendCommandResponse(response) {
    if (response.error) {
        return {
            message: response.error,
            type: 'error'
        };
    } else if (response.warnings) {
        return {
            message: response.warnings[0],
            type: 'warning'
        }
    } else {
        return response.message;
    }
}

export function parseSendCommandError(error) {
    return {
        message: error?.response?.message,
        type: 'error'
    };
}